import config from 'config';
import { http_client } from './api';

const generateReport = async (cabangId, month, year) => {
  const params = new URLSearchParams();
  if (cabangId) {
    params.append('cabang_id', cabangId);
  }
  if (month) {
    params.append('month', month);
  }
  if (year) {
    params.append('year', year);
  }
  return http_client.get(config.apiUrl + 'operational-report/generate?' + params.toString()).then((response) => {
    return response.data;
  });
};

const LaporanOperasionalService = {
  generateReport
};

export default LaporanOperasionalService;

